module.exports = __webpack_public_path__ + "img/Ridning.da0cb967.jpg";